<template>
  <div>
    <el-form ref="auditForm" :model="auditForm" label-width="0px">
      <div class="tips">
        审核意见
        <el-row style="float: right">
          <el-button size="medium" @click="submitAuditForm(1)" type="primary"
            >通过</el-button
          >
          <el-button
            v-show="mxParams.txlx !== '技术'"
            size="medium"
            @click="submitAuditForm(0)"
            type="warning"
            >驳回</el-button
          >
        </el-row>
      </div>
      <div class="clearfix">
        <el-row v-if="mxParams.admin !== -1">
          <el-col :span="12">
            <el-form-item
              prop="isAdmin"
              label="是否是管理员录入："
              label-width="150px"
            >
              <el-radio-group
                v-model="auditForm.isAdmin"
                @change="handleChangeIsAdmin"
              >
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-show="auditForm.isAdmin === 1">
            <el-form-item label prop="title">
              <el-select
                v-model="auditForm.ygbh"
                filterable
                default-first-option
                style="width: 100%"
                placeholder="请选择审核人"
              >
                <el-option
                  v-for="(item, index) in shrList"
                  :key="index"
                  :label="item.xm"
                  :value="item.ygbh"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-input
          type="textarea"
          placeholder="请输入意见"
          v-model="auditForm.bz"
          maxlength="500"
          show-word-limit
        ></el-input>
      </div>

      <el-row>
        <el-col :span="24">
          <el-form-item label style="margin: 10px 0">
            <el-upload
              :action="action"
              :data="parm"
              ref="upload"
              :headers="headers"
              :on-change="handleChange"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :show-file-list="false"
              multiple
            >
              <el-button type="primary" icon="el-icon-upload" plain
                >批注意见附件</el-button
              >
              <div class="upload-tips">
                (单个文件不能超过50M，支持所有扩展名)
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
        <div v-show="cgw.cgwList.length > 0">
          <el-table
            :data="cgw.cgwList"
            size="mini"
            highlight-current-row
            :header-cell-style="tableHeaderColor"
            :default-sort="{ prop: 'date', order: 'descending' }"
            tooltip-effect="dark"
          >
            <template slot="empty">
              <div class="nodata">
                <img src="@/img/nodata.png" alt="" width="150" />
                <div>暂无数据</div>
              </div>
            </template>
            <el-table-column
              label="上传人"
              align="left"
              prop="xm"
              min-width="80px"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              label="上传时间"
              align="left"
              prop="uploadtime"
              min-width="80px"
              :show-overflow-tooltip="true"
            />

            <el-table-column
              prop="filename"
              label="文件名字"
              min-width="250px"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <div>
                  <el-link @click="openPreview(scope.row)" type="primary">
                    {{ scope.row.filename + scope.row.extname }}
                  </el-link>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="大小"
              align="left"
              prop="filesize"
              min-width="100px"
              :show-overflow-tooltip="true"
            />

            <!-- <el-table-column
              label="备注"
              align="left"
              prop="bz"
              min-width="200px"
              :show-overflow-tooltip="true"
            />-->
            <el-table-column label="操作" align="left" prop="name">
              <template slot-scope="scope">
                <!-- <el-button type="text" @click="toBz(scope.row)">备注</el-button> -->
                <el-button @click="downloadFile(scope.row)" type="text"
                  >下载</el-button
                >
                <el-popconfirm
                  title="确定删除吗？"
                  @confirm="deleteFile(scope.row)"
                >
                  <el-button slot="reference" type="text" style="color: red"
                    >删除</el-button
                  >
                </el-popconfirm>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="nodata">
                <img src="@/img/nodata.png" alt="" width="160" />
                <div>暂无数据</div>
              </div>
            </template>
          </el-table>
        </div>
      </el-row>
    </el-form>
    <div>
      <div class="tips">审核人意见</div>
      <el-tabs>
        <el-tab-pane
          v-for="(item, index) in cgw.reviewList"
          :label="'第' + (cgw.reviewList.length - index) + '轮评审'"
          :key="index"
        >
          <el-tabs type="card">
            <el-tab-pane v-for="(it, i) in item.reviewList" :key="i">
              <span slot="label">
                {{ it.xm + "/" }}
                <el-tag type="success" size="small" v-show="it.status === 1"
                  >通过</el-tag
                >
                <el-tag type="danger" size="small" v-show="it.status === 0"
                  >不通过</el-tag
                >
                <el-tag size="small" v-show="it.status === 2">未审核</el-tag>
              </span>
              <el-card class="box-card" v-show="it.status !== 2" shadow="hover">
                <div slot="header" class="clearfix">
                  <span>{{ it.sj }}</span>
                </div>
                <div class="text item">{{ it.bz }}</div>
              </el-card>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-show="cgw.cgwYtjList.length > 0 || this.mxParams.bz">
      <div class="tips">成果物</div>

      <div v-show="mxParams.bz" style="margin-bottom: 10px">
        备注 ： {{ this.mxParams.bz }}
      </div>
      <el-table
        v-show="cgw.cgwYtjList.length > 0"
        :data="cgw.cgwYtjList"
        size="mini"
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="150" />
            <div>暂无数据</div>
          </div>
        </template>
        <el-table-column
          label="上传人"
          align="left"
          prop="xm"
          min-width="80px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{
              scope.row.ygbh === scope.row.uploader
                ? scope.row.xm + "(认领人)"
                : scope.row.xm + "(协作人)"
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="上传时间"
          align="left"
          prop="uploadtime"
          min-width="80px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          prop="filename"
          label="文件名字"
          min-width="250px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              <el-link @click="openPreview(scope.row)" type="primary">
                {{ scope.row.filename + scope.row.extname }}
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="大小"
          align="left"
          prop="filesize"
          min-width="100px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="备注"
          align="left"
          prop="bz"
          min-width="200px"
          :show-overflow-tooltip="true"
        />
        <el-table-column label="操作" align="left" prop="name">
          <template slot-scope="scope">
            <el-button @click="downloadFile(scope.row)" type="text"
              >下载</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </div>
    <div v-show="cgw.cgwPzYtjList.length > 0">
      <div class="tips">成果物批注附件</div>
      <el-table
        :data="cgw.cgwPzYtjList"
        size="mini"
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="上传人"
          align="left"
          prop="xm"
          min-width="80px"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="上传时间"
          align="left"
          prop="uploadtime"
          min-width="80px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          prop="filename"
          label="文件名字"
          min-width="250px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div>
              <el-link @click="openPreview(scope.row)" type="primary">
                {{ scope.row.filename + scope.row.extname }}
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="大小"
          align="left"
          prop="filesize"
          min-width="100px"
          :show-overflow-tooltip="true"
        />

        <el-table-column label="操作" align="left" prop="name">
          <template slot-scope="scope">
            <el-button @click="downloadFile(scope.row)" type="text"
              >下载</el-button
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </div>

    <el-dialog
      title="编辑备注"
      :visible.sync="bzDialog"
      width="500px"
      top="100px"
      :closeOnClickModal="false"
      :modal="false"
    >
      <el-input
        v-model="file.bz"
        type="textarea"
        :rows="2"
        placeholder="请输入内容"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveBz">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getCgwReviewerListByRlId } from "@/api/cgw.js";

export default {
  name: "auditForm",
  computed: { ...mapGetters(["cgw"]) },
  props: {
    mxParams: {
      type: Object,
    },
  },
  data() {
    return {
      fileList: [],
      auditForm: {
        isAdmin: 0,
        ygbh: null,
        bz: null,
      },
      action: window.g.apiUrl + "pmp/cgw/cgwUpload",
      parm: {},
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      bzDialog: false,
      file: {},
      shrList: [],
    };
  },
  mounted() {
    this.parm = {
      type: 3,
      taskId: this.mxParams.taskId,
      rwbh: this.mxParams.rwbh,
    };

    this.$store.dispatch("cgw/fetchCgwListAction", { type: 3, isTj: 0 });

    this.$store.dispatch("cgw/fetchCgwYtjListAction", {
      rlId: this.mxParams.rlId,
    });
    this.$store.dispatch("cgw/fetchCgwPzYtjListAction", {
      rlId: this.mxParams.rlId,
    });
    this.$store.dispatch("cgw/fetchCgwReviewAction", {
      rlId: this.mxParams.rlId,
    });
  },
  methods: {
    handleChangeIsAdmin(e) {
      if (e === 1) {
        this.getCgwReviewerListByRlId();
      }
    },
    getCgwReviewerListByRlId() {
      getCgwReviewerListByRlId(this.mxParams.rlId).then((res) => {
        if (res.code == 0) {
          this.shrList = res.data;
        }
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    hideDialog() {
      this.$emit("hideDialog");
    },
    toBz(file) {
      this.file = file;
      this.bzDialog = true;
    },
    saveBz() {
      this.$store
        .dispatch("cgw/fetchUpdateBzAction", {
          fileId: this.file.fileid,
          bz: this.file.bz,
        })
        .then((success) => {
          if (success.code === 0) {
            this.$store.dispatch("cgw/fetchCgwListAction", {
              type: 3,
              isTj: 0,
            });
          }
        });
      this.bzDialog = false;
    },
    openPreview(row) {
      const url = row.previewurl;
      window.open(url);
    },
    downloadFile(row) {
      const filePath = row.url;
      const fileName = row.filename + row.extname;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    deleteFile(file) {
      this.$store
        .dispatch("cgw/fetchDeleteFileAction", {
          fileId: file.fileid,
          path: file.url,
        })
        .then((success) => {
          if (success.code === 0) {
            this.$store.dispatch("cgw/fetchCgwListAction", {
              type: 3,
              isTj: 0,
            });
          }
        });
    },
    beforeUpload(file) {
      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        return false;
      }
    },
    handleChange(file, fileList) {
      this.$store.dispatch("cgw/fetchCgwListAction", { type: 3, isTj: 0 });
    },
    submitAuditForm(type) {
      if (1 === this.auditForm.isAdmin && !this.auditForm.ygbh) {
        this.$message.error("请选择审核人！");
        return;
      }
      if (!this.mxParams.id && !this.auditForm.ygbh) {
        this.$message.error(
          "您不是该任务的成果物审核人，如果你是部门管理员，请选择管理员操作，并选择对应的审核人！"
        );
        return;
      }
      if (!this.auditForm.bz) {
        this.$message.error("请输入意见！");
        return;
      }
      const fileids = [];
      this.cgw.cgwList.forEach((item) => {
        fileids.push(item.fileid);
      });
      this.auditForm.status = type;

      this.$store
        .dispatch("cgw/saveCgwAuditAction", {
          fileIds: fileids.toString(),
          id: 1 === this.auditForm.isAdmin ? null : this.mxParams.id,
          rlId: this.mxParams.rlId,
          taskId: this.mxParams.taskId,
          status: type,
          isAdmin: this.auditForm.isAdmin,
          ygbh: this.auditForm.ygbh,
          rwmc: this.mxParams.rwmc,
          txlx: this.mxParams.txlx,
          bz: this.auditForm.bz,
        })
        .then((success) => {
          if (success.code === 0) {
            this.$message.success("保存成功!");
            this.$emit("hideDialog");
            this.$emit("getList");
          } else {
            this.$message.error(success.msg);
          }
        });
      // saveTaskApplyAudit(this.auditForm).then((res) => {
      //   if (res.code == 0) {
      //     this.$message.success(res.msg);
      //     this.$emit("changeRwshDialog");
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // });
    },
  },
};
</script>
<style lang="less" scoped>
.uploadButton {
  text-align: right;
  margin-top: 10px;
}
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding: 0 15px;
  margin: 15px 0;
}
.upload-tips {
  position: absolute;
  top: 0px;
  left: 170px;
}
</style>